<template>
  <svg stroke-linecap="round" version="1.1" viewBox="0 0 10000 12000" xml:space="preserve"
       xmlns="http://www.w3.org/2000/svg"><path  d="M4693.24 515.53c315.6,2419.59 841.58,4839.16 473.4,6785.35 -368.18,1946.2 -499.69,1814.72 -262.99,2393.3 236.69,578.59 927.01,802.14 729.8,1157.18 -197.21,355.03 -1194.68,1023.03 -1209.76,558.88 -13.47,-414.15 716.68,-894.19 841.6,-782.41 124.92,111.78 -269.57,407.64 -269.57,407.64" fill-opacity="0" stroke="#58E2B0" stroke-dasharray="100000" stroke-dashoffset="1000" stroke-miterlimit="22.9526" stroke-width="200px"></path></svg>
</template>

<script lang="ts" setup>
</script>
